import * as React from 'react';
import { SVGProps } from 'react';

const SvgSharpEdge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M32.4051 26.8331V12.5593L12.7195 33.8685L32.4051 26.8331Z'
      stroke='#000'
      strokeLinejoin='round'
    />
    <path
      d='M8.41016 26.7421L28.237 5.49341L32.4102 12.5598L12.7217 33.8593L8.41016 26.7421Z'
      stroke='#000'
      strokeLinejoin='round'
    />
    <path d='M8.64453 27.1292L12.4872 33.4723' fill='#FFEFE6' />
    <path
      d='M 8.399 26.741 L 12.729 33.87'
      stroke='#FF4D00'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default SvgSharpEdge;
